import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Pagination } from 'app/shared/models/pagination';

@Component({
  selector: 'app-paging-table',
  templateUrl: './paging-table.component.html',
  styleUrls: ['./paging-table.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PagingTableComponent {

  @Input()
  page: Pagination = new Pagination();

  @Output()
  eventPaging: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  eventAccept: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  eventReject: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  eventOtherLink1: EventEmitter<any> = new EventEmitter<any>();

  messages = { emptyMessage: `` }

  constructor() { 
  }

  pagingEvent(event: any): void {
    this.eventPaging.emit(event.page);
  }

  onRejectClicked(row: any): void {    
    this.eventReject.emit(row);
  }

  onAcceptClicked(row: any): void {    
    this.eventAccept.emit(row);
  }

  onOtherLink1Clicked(row: any): void {    
    this.eventOtherLink1.emit(row);
  }

  hasCellPipe(col: any, validatePipe: boolean) {
    let hasPipe = false;
    if(col.prop == 'reject' || col.prop == 'accept' || col.prop == 'otherLink1' || col.prop == 'otherLink2') {
      hasPipe = false;
    } else if(validatePipe && col.pipeDate) {
      hasPipe = true;
    } 
    return hasPipe;
  }

  otherLinkShowAndRequered(col: any, row: any, type: string) {
      let showAndRequered = false;
    if((!col.val && col.type == type) || (col.val && row[col.val] && col.type == type)) {
      showAndRequered = true;
    }
    return showAndRequered;
  }
}